.browser-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--off-white);
    align-items: center;
    justify-content: center;
    padding: 32px;
    box-sizing: border-box;
}

.browser-window {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: 800px;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--off-white-dk);
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.browser-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    background-color: var(--off-white);
    border-bottom: 1px solid var(--off-white-dk);
    flex-shrink: 0;
}

.browser-dots {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.dot-red {
    background-color: #ff5f57;
}

.dot-yellow {
    background-color: #febc2e;
}

.dot-green {
    background-color: #28c840;
}

.url-bar {
    flex: 1;
    background-color: var(--off-white-dk);
    border-radius: 4px;
    padding: 6px 10px;
    min-width: 0;
}

.url-text {
    font-size: 12px;
    color: var(--grey);
    font-family: var(--font-mono);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
}

.browser-content {
    flex: 1;
    overflow: hidden;
    position: relative;
    background-color: white;
}

.iframe-scaler {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
    pointer-events: none;
}

.iframe {
    width: 100%;
    height: 100%;
    border: none;
    background-color: white;
}
